import React, {useState} from 'react';

function Pagination(props) {

  return (<>
    <div className='w-full
         flex justify-center mb-6
         '>
        <button className='
            p-2 
            border-2 
            border-indigo-500
            text-indigo-500
            border-r-0
            rounded-l-xl
            '
            onClick={props.gotoPrevPage}
            >Previous</button>
        <button className='
            p-2 
            border-2 
            border-indigo-500
            text-indigo-500
            bg-gray-200
            '>{props.pageNumber}</button>
        <button className='
            p-2 
            border-2 
            border-indigo-500
            text-indigo-500
            border-l-0
            rounded-r-xl
            '
            onClick={props.gotoNextPage}
            >Next</button>
    </div>
  </>);
}

export default Pagination;
